"use client";

import { Accessibility, Car, TrainFront as Train } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StudioLocation() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: infoRef,
    isVisible: infoVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const practicalInfo = [{
    icon: Car,
    label: "پارکینگ",
    detail: "اختصاصی و خیابانی"
  }, {
    icon: Train,
    label: "دسترسی",
    detail: "نزدیک به ایستگاه مترو"
  }, {
    icon: Accessibility,
    label: "دسترسی‌پذیری",
    detail: "ورودی بدون پله"
  }];
  return <section data-section-id="3793" id="موقعیت-استودیو-arq" className="bg-background text-foreground py-20 md:py-28 lg:py-32 px-4 md:px-8 lg:px-12 overflow-hidden">
      {}
      <div ref={headerRef} className={`max-w-3xl mx-auto text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <p className="font-mono text-xs md:text-sm uppercase tracking-widest mb-10 md:mb-12" style={{
        color: "var(--primary)"
      }}>
          — موقعیت استودیو
        </p>
        <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] mb-10 md:mb-12 text-foreground">
          بازدید با <em className="italic font-light">هماهنگی قبلی</em>.
        </h2>
        <p className="text-base md:text-base leading-relaxed text-muted-foreground max-w-[580px] mx-auto">
          استودیوی طراحی آرتین پذیرای شماست تا در فضایی الهام‌بخش، ایده‌های خود را برای بازطراحی محیط زندگی یا کارتان با ما در میان بگذارید.
        </p>
      </div>

      {}
      <div ref={mapRef} className={`relative mt-16 md:mt-20 max-w-7xl mx-auto transition-all duration-1000 ease-out delay-150 ${mapVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="relative w-full border overflow-hidden" style={{
        aspectRatio: "16 / 9",
        borderColor: "var(--border)",
        backgroundColor: "var(--card)"
      }}>
          {}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <defs>
              <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
                <path d="M 80 0 L 0 0 0 80" fill="none" stroke="var(--border)" strokeWidth="0.5" opacity="0.3" />
              </pattern>
              <radialGradient id="emberGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="var(--primary)" stopOpacity="0.6" />
                <stop offset="100%" stopColor="var(--primary)" stopOpacity="0" />
              </radialGradient>
            </defs>

            {}
            <rect width="1600" height="900" fill="var(--background)" />
            <rect width="1600" height="900" fill="url(#grid)" />

            {}
            <g stroke="var(--primary)" strokeWidth="2" fill="none" opacity="0.7">
              <path d="M 0 450 L 1600 450" />
              <path d="M 800 0 L 800 900" />
              <path d="M 0 200 L 1600 200" opacity="0.4" />
              <path d="M 0 700 L 1600 700" opacity="0.4" />
              <path d="M 300 0 L 300 900" opacity="0.4" />
              <path d="M 1300 0 L 1300 900" opacity="0.4" />
              <path d="M 200 100 L 1500 800" opacity="0.3" strokeWidth="1" />
              <path d="M 1400 100 L 100 800" opacity="0.3" strokeWidth="1" />
            </g>

            {}
            <g fill="var(--muted)" opacity="0.5">
              <rect x="100" y="100" width="160" height="80" />
              <rect x="350" y="100" width="400" height="80" />
              <rect x="850" y="100" width="400" height="80" />
              <rect x="1340" y="100" width="200" height="80" />
              <rect x="100" y="250" width="160" height="160" />
              <rect x="350" y="250" width="400" height="160" />
              <rect x="850" y="250" width="400" height="160" />
              <rect x="1340" y="250" width="200" height="160" />
              <rect x="100" y="490" width="160" height="160" />
              <rect x="350" y="490" width="400" height="160" />
              <rect x="850" y="490" width="400" height="160" />
              <rect x="1340" y="490" width="200" height="160" />
              <rect x="100" y="740" width="160" height="120" />
              <rect x="350" y="740" width="400" height="120" />
              <rect x="850" y="740" width="400" height="120" />
              <rect x="1340" y="740" width="200" height="120" />
            </g>

            {}
            <g fill="var(--muted-foreground)" fontFamily="JetBrains Mono, monospace" fontSize="10" opacity="0.6">
              <text x="450" y="145">منطقه مرکزی</text>
              <text x="950" y="145">خیابان اصلی</text>
              <text x="450" y="385">بلوار طراحی</text>
              <text x="950" y="385">میدان هنر</text>
              <text x="450" y="625">خیابان معماری</text>
              <text x="950" y="625">کوچه خلاقیت</text>
            </g>

            {}
            <g transform="translate(800, 450)">
              <circle r="40" fill="url(#emberGlow)">
                <animate attributeName="r" values="30;60;30" dur="2.5s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.8;0.2;0.8" dur="2.5s" repeatCount="indefinite" />
              </circle>
              <circle r="24" fill="url(#emberGlow)" opacity="0.7" />
              <circle r="10" fill="var(--primary)" />
              <circle r="4" fill="var(--primary-foreground)" />
            </g>
          </svg>

          {}
          <div className="absolute bottom-4 left-4 md:bottom-8 md:left-8 w-[280px] sm:w-[320px] border p-5 md:p-6" style={{
          backgroundColor: "var(--card)",
          borderColor: "var(--border)"
        }}>
            <p className="font-mono text-[11px] uppercase tracking-widest mb-3" style={{
            color: "var(--primary)"
          }}>
              استودیو طراحی آرتین
            </p>
            <address className="not-italic text-[15px] leading-snug text-foreground mb-4">
              تهران، خیابان هنر<br />
              پلاک ۱۲، واحد ۵
            </address>
            <div className="h-px w-full mb-4" style={{
            backgroundColor: "var(--border)"
          }} />
            <div className="flex flex-col gap-2.5">
              <Link to="https://maps.google.com" newTab className="font-mono text-[11px] uppercase tracking-widest transition-opacity hover:opacity-70" style={{
              color: "var(--primary)"
            }}>
                مسیریابی →
              </Link>
              <Link to="/TalkWithUsPage" className="font-mono text-[11px] uppercase tracking-widest transition-opacity hover:opacity-70" style={{
              color: "var(--primary)"
            }}>
                هماهنگی بازدید →
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div ref={infoRef} className={`max-w-7xl mx-auto mt-16 md:mt-20 transition-all duration-1000 ease-out delay-300 ${infoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {practicalInfo.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center md:items-start md:text-left">
                <Icon className="w-6 h-6 mb-4" strokeWidth={1} style={{
              color: "var(--primary)"
            }} />
                <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
                  <span className="text-foreground">{item.label}</span>
                  <span className="mx-2 opacity-50">—</span>
                  <span>{item.detail}</span>
                </p>
              </div>;
        })}
        </div>

        {}
        <div className="flex justify-center mt-14 md:mt-16">
          <Button asChild variant="outline" size="lg" className="font-mono text-xs uppercase tracking-widest bg-transparent border-border hover:bg-primary hover:text-primary-foreground hover:border-primary px-8 h-12">
            <Link to="/TalkWithUsPage">رزرو وقت مشاوره</Link>
          </Button>
        </div>
      </div>
    </section>;
}